export default __webpack_public_path__ + "static/media/PMS-BG.45732fcb.svg";